import React, { Component } from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
// import nl2br from 'react-nl2br';
import profile1 from '../../../assets/interviews/1/profile.jpg';
import profile2 from '../../../assets/interviews/2/profile.jpg';
import profile3 from '../../../assets/interviews/3/profile.jpg';
import profile4 from '../../../assets/interviews/4/profile.jpg';
import profile5 from '../../../assets/interviews/5/profile.jpg';
import profile6 from '../../../assets/interviews/6/profile.jpg';
import profile7 from '../../../assets/interviews/7/profile.jpg';
import profile8 from '../../../assets/interviews/8/profile.jpg';
import profile9 from '../../../assets/interviews/9/profile.jpg';
import profile10 from '../../../assets/interviews/10/profile.jpg';

const Container = styled.div`
  padding-top: 3rem;
  padding-bottom: 1rem;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 4rem;
  font-size: 2rem;
  background-color: #fa5856;
  padding: 1rem;
  color: #fff;
  font-size: 2.5rem;
`;

const Judge = styled.img``;

const Card = styled.a`
  border-radius: 0px !important;
  margin-bottom: 3rem;
`;

const CardFooter = styled.div`
  background-color: #fa5856 !important;
  border-radius: 0px !important;
  text-align: center;
  color: #fff;
  font-size: 0.95rem;
`;

class Interviews extends Component {
  render() {
    // const { intl } = this.props;

    return (
      <Container className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <Title>
              <FormattedMessage id="Interviews.Title" />
            </Title>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/1/interview.pdf">
              <Judge
                src={profile1}
                alt="profile1"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.1" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/2/interview.pdf">
              <Judge
                src={profile2}
                alt="profile2"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.2" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/3/interview.pdf">
              <Judge
                src={profile3}
                alt="profile3"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.3" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/4/interview.pdf">
              <Judge
                src={profile4}
                alt="profile4"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.4" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/5/interview.pdf">
              <Judge
                src={profile5}
                alt="profile5"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.5" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/6/interview.pdf">
              <Judge
                src={profile6}
                alt="profile6"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.6" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/7/interview.pdf">
              <Judge
                src={profile7}
                alt="profile7"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.7" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/8/interview.pdf">
              <Judge
                src={profile8}
                alt="profile8"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.8" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/9/interview.pdf">
              <Judge
                src={profile9}
                alt="profile9"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.9" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="card" target="_blank" href="/interview/10/interview.jpg">
              <Judge
                src={profile10}
                alt="profile10"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Interviews.Profile.10" />
              </CardFooter>
            </Card>
          </div>
        </div>
      </Container>
    );
  }
}

export default injectIntl(Interviews);
